import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrainerProductivityCard = ({ trainers }) => {
  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Top Performing Trainers
      </h3>
      <div className="space-y-4">
        {trainers?.map((trainer, index) => (
          <div 
            key={index} 
            className="flex items-center gap-4 p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
          >
            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-14 h-14 rounded-full overflow-hidden">
                  <Image 
                    src={trainer?.avatar} 
                    alt={trainer?.avatarAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-card border-2 border-card flex items-center justify-center">
                  <span className="text-xs font-bold text-primary">#{index + 1}</span>
                </div>
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-base font-semibold text-foreground truncate">{trainer?.name}</h4>
              <p className="text-sm text-muted-foreground">{trainer?.specialty}</p>
            </div>
            <div className="flex flex-col items-end gap-1">
              <div className="flex items-center gap-2">
                <Icon name="Users" size={16} color="var(--color-primary)" />
                <span className="text-sm font-medium text-foreground data-text">{trainer?.clients}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="DollarSign" size={16} color="var(--color-success)" />
                <span className="text-sm font-medium text-success data-text">${trainer?.revenue}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainerProductivityCard;